import styled from 'styled-components';

export const Label = styled.label`
  &&& {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    border-radius: 4px;
    padding: 12px 12px 12px 65px;
    cursor: pointer;
    &:before {
      background: #EDF0F1;
      z-index: 1;
      position: absolute;
      top: 50%;
      left: 12px;
      transform: translateY(-50%);
      content: '';
      display: block;
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      border-radius: 5px;
    }
    &:after {
      z-index: 99;
      position: absolute;
      top: 48%;
      left: 15px;
      transform: translateY(-50%) rotate(-45deg);
      content: '';
      display: block;
      width: 16px;
      height: 8px;
      border-left: solid 3px #0066FF;
      border-bottom: solid 3px #0066FF;
      opacity: 0;
    }
  }`;

export const Input = styled.input`
  &&& {
    display: none;
    &:checked + ${Label} {
      &:before {
        background: #0066FF;
        border: none;
      }
      &:after {
        z-index: 99;
        position: absolute;
        top: 48%;
        left: 15px;
        transform: translateY(-50%) rotate(-45deg);
        content: '';
        display: block;
        width: 16px;
        height: 8px;
        border-left: solid 3px #fff;
        border-bottom: solid 3px #fff;
        opacity: 1;
      }
    }
  }`;

export const Textarea = styled.textarea`
  &&& {
    width: 100%;
    border: 1px solid #D8D8D8;
    background: #FFF;
  }`;
